export default __webpack_public_path__ + "static/media/icon-taks-order.dd51a8be.svg";